import "requestidlecallback-polyfill";
import Vue from "vue";
import App from "./App.vue";
import store from "./store/store";
import vuetify from "./plugins/vuetify";

import permission from "@/lib/permissions/directive";

Vue.config.productionTip = false;
// Otherwise we get "unknown element" errors in the builder, since Vue thinks they're Vue components
Vue.config.ignoredElements = ["lite-vimeo", "lite-youtube"];

Vue.directive("permission", permission);

new Vue({
  store,
  // @ts-ignore
  vuetify,
  render: h => h(App)
}).$mount("#app");
